import React from 'react';
import { connect } from 'react-redux';
import titleToSectionKey from '../../../../../../../../../store/helpers/titleToSectionKeyDict';
import { Tools as ToolsWrapper } from '../../../../../../UI/Editor/EditSpace/EditorPane/RenderContent/arrayItems';
import componentSection from '../../../../LeftPane/componentSection';
import Add from './add';
import DeleteItem from './delete';

const Tools = (props) => {
  const {
    editor,
    node,
    stopDrag,
    formatType,
    isFocused,
    statusBarRef,
    mostUsedToolSetRef,
    rolesCount,
  } = props;

  return (
    <ToolsWrapper
      onMouseDown={stopDrag}
      contentEditable={false}
      isFocused={isFocused}
    >
      <DeleteItem
        mostUsedToolSetRef={mostUsedToolSetRef}
        node={node}
        editor={editor}
        formatType={formatType}
        rolesCount={rolesCount}
      />
      <Add
        statusBarRef={statusBarRef}
        editor={editor}
        node={node}
        formatType={formatType}
      />
    </ToolsWrapper>
  );
};

const mapStateToProps = (state, ownProps) => {
  const {
    node: { type },
  } = ownProps;
  const sectionTitle = componentSection[type];
  const sectionKey = titleToSectionKey[sectionTitle];

  return {
    [sectionKey]: state.editResumeFormReducer[sectionKey], // re-renders organization details when there is an update in rolesCount properties
  };
};

export default connect(mapStateToProps)(Tools);
